import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Modal } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { DocumentsPublicType } from '../../pages/EditDocumentCategoryPage/types';
import { routerPath } from '../../router/routerPath';
import { logout } from '../../store/authStore/auth.action';
import { authContext } from '../../store/authStore/AuthContext';
import { NavbarTextLinkButton } from '../../styles/styled';
import useWindowDimensions from '../../utils/getScreenHeight';
import { DocumentsNavigationComponent } from '../DocumentsNavigationComponent/DocumentsNavigationComponent';
import { LoginPopup } from '../LoginPopup';
import ResponsibleNavbar from '../ResponsibleNavbar';
import { LayoutsContainer, NavbarContainerUI, NavbarLayout, TwoNavsContainer } from './styled';

export const NavbarComponent = () => {
  const [popupState, setPopupState] = useState(false);
  const { state, dispatch } = useContext(authContext);
  const [documentsNavState, setDocumentNav] = useState<boolean>(false);
  const [documentsState, setDocuments] = useState<DocumentsPublicType>([]);
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<DocumentsPublicType>(endpoints.getPublicDocuments());

        setDocuments(response.data);
      } catch (err) {}
    })();
  }, []);

  const profileSpawner = useMemo(() => {
    if (state.isFederal || state.isSuperFederal) return <Link to={routerPath.application}>Личный кабинет</Link>;
    else if (state.isRepresentative) return <Link to={routerPath.representativeProfile}>Личный кабинет</Link>;
    else if (state.isExpert) return <Link to={routerPath.expertUserProfile}>Личный кабинет</Link>;
    else if (state.isPovs) return <Link to={routerPath.povsLk}>Личный кабинет</Link>;
    else if (state.isNms) return <Link to={routerPath.nmsProfile}>Личный кабинет</Link>;
  }, [state]);

  return width > 785 ? (
    <TwoNavsContainer>
      <NavbarContainerUI>
        <LayoutsContainer>
          <NavbarLayout>
            <Link to="/">Федеральный перечень учебников</Link>
            <Link to={routerPath.listOfOrganisations}>Перечень организаций</Link>

            <NavbarTextLinkButton onClick={() => setDocumentNav(!documentsNavState)}>Документы</NavbarTextLinkButton>
          </NavbarLayout>
          {!state.token ? (
              <NavbarLayout style={{ opacity: '0' }}>
                <button className="text" onClick={() => setPopupState(!popupState)} style={{ opacity: '0' }}>
                  Вход
                </button>
                <Link to={routerPath.register_representative}>Регистрация</Link>
              </NavbarLayout>
          ) : (
              <NavbarLayout style={{ opacity: '0' }}>
                {profileSpawner}
                <button
                    className="text link"
                    onClick={() => {
                      dispatch(logout());
                      navigate(routerPath.home);
                    }}
                >
                  Выход
                </button>
              </NavbarLayout>
          )}
        </LayoutsContainer>

        <Modal visible={popupState} footer={null} onCancel={() => setPopupState(false)}>
          <LoginPopup />
        </Modal>
      </NavbarContainerUI>
      {documentsNavState && (
        <DocumentsNavigationComponent closeNav={() => setDocumentNav(false)} documents={documentsState} />
      )}
    </TwoNavsContainer>
  ) : (
    <ResponsibleNavbar />
  );
};
